import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { daysIndex } from '../../../../shared';
import { TotalHoursWrapper, TotalsCol, TotalsHR, TotalHoursSticky } from './styled';
import StickyNode from 'react-stickynode';
import { Grid } from '@mantine/core';

// eslint-disable-next-line react/display-name
const TotalHoursFooter = React.memo(({ totalHours, applyDeletableRowStyles }) => (
  <TotalHoursSticky>
    <StickyNode
      enabled={true}
      bottomBoundary={0}>
      <TotalHoursWrapper applyDeletableRowStyles={applyDeletableRowStyles}>
        <Grid.Col xs={12} sm={12} md={7} lg={8}>
          <p>Total</p>
        </Grid.Col>
        <Grid.Col xs={12} sm={8} md={5} lg={4}>
          <Grid grow>
            {
              totalHours.map((total, index) => (
                <TotalsCol span={1} key={index.toString()}>
                  <p data-test={`total-${daysIndex[index]}`}>
                    {typeof total === 'number'
                      ? (Number.isInteger(total) ? total : total.toFixed(2))
                      : total}
                  </p>
                </TotalsCol>
              ))
            }
          </Grid>
        </Grid.Col>
      </TotalHoursWrapper>
    </StickyNode>
    <TotalsHR />
  </TotalHoursSticky>
));

TotalHoursFooter.propTypes = {
  totalHours: PropTypes.arrayOf(Number),
};

export default TotalHoursFooter;